import { useCallback, useEffect, useState } from "react";

export const useHash = () => {
  const [hash, setHash] = useState(() =>
    typeof window !== "undefined" ? window.location.hash : undefined,
  );

  const hashChangeHandler = useCallback(() => {
    if (typeof window !== "undefined") {
      setHash(window.location.hash);
    } else {
      setHash(undefined);
    }
  }, []);

  useEffect(() => {
    window.addEventListener("hashchange", hashChangeHandler);
    return () => {
      window.removeEventListener("hashchange", hashChangeHandler);
    };
  }, []);

  const updateHash = useCallback(
    (newHash: string) => {
      if (newHash !== hash && window) window.location.hash = newHash;
    },
    [hash],
  );

  return [hash, updateHash];
};
